export default __webpack_public_path__ + "static/media/Pending.179dad81.svg";